export const ControllNav = (URL) => {
    let ctrl = false;
    let part = URL.split('/')[1];
    if(part.length) {
        NavLocArray.forEach((value) => {
            if(value === part){
                ctrl = true;
            }
        })
    } else {
        ctrl = false
    }
    return ctrl
}
const NavLocArray = [
    'contactus',
    'aboutus',
    'search',
    'shops',
    'shop',
    'goods',
    'good',
    'category',
    'categories',
    'shopgood',
    'profile',
    'buying',
    'user',
    'order',
    'cp',
    'affiliate',
    'code',
    'rules',
    'blog',
    'questions',
    'singup-seller',
    'campaign',
    'errorrpagesss',
    'brands',
    'brand',
    'category-app',
    'categorypage',
    'application',
    'personel'
];




// const locationArray = [
//     'contactus',
//     'aboutus',
//     'search',
//     'shops',
//     'shop',
//     'goods',
//     'good',
//     'shopgood',
//     'profile',
//     'buying',
//     'user',
//     'order',
//     'cp',
//     'affiliate',
//     'code',
// ];

